'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var exporter = require('ipfs-unixfs-exporter');

var _require = require('../utils'),
    normalizeCidPath = _require.normalizeCidPath,
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      preload = _ref.preload;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _cat = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfsPath, options) {
      var pathComponents, file;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              ipfsPath = normalizeCidPath(ipfsPath);

              if (options.preload !== false) {
                pathComponents = ipfsPath.split('/');
                preload(pathComponents[0]);
              }

              _context.next = 5;
              return _awaitAsyncGenerator(exporter(ipfsPath, ipld, options));

            case 5:
              file = _context.sent;

              if (!(file.unixfs && file.unixfs.type.includes('dir'))) {
                _context.next = 8;
                break;
              }

              throw new Error('this dag node is a directory');

            case 8:
              if (file.content) {
                _context.next = 10;
                break;
              }

              throw new Error('this dag node has no content');

            case 10:
              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(file.content(options)), _awaitAsyncGenerator), "t0", 11);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function cat(_x, _x2) {
      return _cat.apply(this, arguments);
    }

    return cat;
  }());
};